var React = require('react');

function ExportRule (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.293 11.293 12 18l6.707-6.707a1 1 0 0 0-1.414-1.414L13 14.172V2.586a1 1 0 1 0-2 0v11.586L6.707 9.879a1 1 0 0 0-1.414 1.414zM4 15a1 1 0 1 0-2 0v4a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 1 0-2 0v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4z","fill":"#fff"}));
}

ExportRule.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ExportRule;

ExportRule.default = ExportRule;
